import { api } from "@/client/api";
import { configs } from "@/configs";
import { parseDateTimeFromPrisma, parseURLSearchParams } from "@/utils";
import { Booking, Trainer } from "@/models";
import { DateTime } from "luxon";

type GetAvailableTrainersInput = {
  start: DateTime;
  end: DateTime;
};

type CreateTrainerBookingInput = {
  trainerId: number;
  start: DateTime;
  end: DateTime;
};

export async function getTrainers(): Promise<Trainer[]> {
  const response = await api.get(`${configs.apiUrl}/member/trainers`);
  return parseDateTimeFromPrisma(response.data) as Trainer[];
}

export async function getTrainer(trainerId: number): Promise<Trainer> {
  const response = await api.get(
    `${configs.apiUrl}/member/trainers/${trainerId}`
  );
  return parseDateTimeFromPrisma(response.data) as Trainer;
}

export async function getAvailableTrainers({
  start,
  end,
}: GetAvailableTrainersInput): Promise<Trainer[]> {
  const params = parseURLSearchParams({
    start: start.toISO(),
    end: end.toISO(),
  });

  const response = await api.get(
    `${configs.apiUrl}/member/trainers/available?${params}`
  );
  return parseDateTimeFromPrisma(response.data) as Trainer[];
}

export async function createTrainerBooking({
  trainerId,
  start,
  end,
}: CreateTrainerBookingInput) {
  const response = await api.post(
    `${configs.apiUrl}/member/trainers/${trainerId}/bookings`,
    { startedAt: start.toISO(), endedAt: end.toISO() }
  );
  return parseDateTimeFromPrisma(response.data) as Booking;
}
